import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { AuthService } from '../../_services/auth.service';
import { NotificationService, NotificationType } from '../../_services/notification.service'

import { FormControl, Validators, FormGroup } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss']
})




export class SetNewPasswordComponent implements OnInit {
  passwordNotMatch = "";
  public confirmPasswordShow;
  public passwordShow;
  public prevPasswordShow;
  public tokenValid: any = "validating"; 
  @ViewChild('passwordInfo', { static: false }) public tooltip: NgbTooltip;


  setNewPasswordForm = new FormGroup({
    password: new FormControl('', [Validators.required,Validators.minLength(8)],),
    confirmPassword: new FormControl('', [Validators.required,Validators.minLength(8)]),
  });

  resetToken

  constructor(private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _authService: AuthService,
    private _notificationService: NotificationService, ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      this.resetToken = params['id']
     
    })
    this._authService.validateToken(this.resetToken).subscribe((result) => {
      this.tokenValid = true
    }, (error) => {
      if (error.status == 400) {
        this.tokenValid = false
      }
    })
  }

  sendNewPassword() {
    var value = this.setNewPasswordForm.value
  
    if (value["password"] != value["confirmPassword"]) {
      this.passwordNotMatch = "error"
    } else {
      value["token"] = this.resetToken
      this.passwordNotMatch = "success"
      let notificationID = this._notificationService.showNotification({
        message: "Checking..",
        type: NotificationType.info,
        isLoading: true
      })
      this._notificationService.notificationID.push(notificationID);

      this._authService.resetPassowrd(value).subscribe((result) => {
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this._router.navigate(['/login/'])
      }, (error) => {
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }
      })
      // Post from here
    }
  }

}
